module.exports = __webpack_public_path__ + "static/media/stripe.082e98ec.png";